import React from "react";
import { defineMessages } from "react-intl";
import { Dialog } from "cci-component";
import OfficeSelectionList from "./SelectionList";

const messages = defineMessages({
  offices: {
    id: "Offices",
    defaultMessage: "Offices"
  }
});

/**
 * Modal dialog to with list of offices to select from.
 * 
 * Props:
 * - onSelected: Function that is called when the user taps one of the offices in the list.
 */
const SelectionDialog = props => (
  <Dialog
    title={messages.offices}
    width={.5}
    height={.5}
    {...props}
  >
    <OfficeSelectionList onSelected={props.onSelected} style={{flex: 1}} />
  </Dialog>
);

export default SelectionDialog;
